import { render, staticRenderFns } from "./TS-info-modal.vue?vue&type=template&id=5dac7251"
import script from "./TS-info-modal.vue?vue&type=script&lang=js"
export * from "./TS-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports